"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHexColour = void 0;
var colourContext = null;
var resolveOver = function (context, fallback, colour) {
    context.fillStyle = fallback;
    context.fillStyle = colour;
    return String(context.fillStyle);
};
// the canvas resolves any CSS colour (names, rgb(), hsl()) the way the browser will paint it
var toHexColour = function (colour) {
    var _a, _b;
    if (!(colour === null || colour === void 0 ? void 0 : colour.trim()))
        return undefined;
    colourContext !== null && colourContext !== void 0 ? colourContext : (colourContext = document.createElement("canvas").getContext("2d"));
    if (!colourContext)
        return colour;
    var resolved = resolveOver(colourContext, "#000000", colour);
    if (resolved !== resolveOver(colourContext, "#ffffff", colour))
        return undefined;
    if (resolved.startsWith("#"))
        return resolved;
    var channels = (_b = (_a = resolved.match(/\d+(\.\d+)?/g)) === null || _a === void 0 ? void 0 : _a.slice(0, 3)) !== null && _b !== void 0 ? _b : [];
    return "#".concat(channels.map(function (channel) { return Math.round(Number(channel)).toString(16).padStart(2, "0"); }).join(""));
};
exports.toHexColour = toHexColour;
